import { compileSync } from '@mdx-js/mdx';

export const compileMDX = (mdx: string) => String(compileSync(mdx, { outputFormat: 'function-body', development: false }));